import { ManageAssessmentService, CustomToastrAction, Dots, AssessmentActionOptions, REDIRECT, CommonAction, MANAGE_ASSESSMENT} from '@/imports-files/pages/clients/recruitments/manage-assessment';
import { addParamsToUrl } from '@/actions/pages/admins/dashboard/clients/common';

export class ManageAssessmentAction
{
  constructor(router, setApiError)
  {
    this.manageAssessmentService  =  new ManageAssessmentService();
    this.customToastrAction     =  new CustomToastrAction(); 
    this.setApiError            =  setApiError;  
    this.router                 =  router;
    this.commonAction           = new CommonAction();
  }

  async listAssessments(params){
    const result    =   await this.manageAssessmentService.listAssessments(params);
    this.setApiError(result.request);
    return result.data;
  }

  async  handleAssessmentPerRowsSorting(column, sortDirection, setAssessmentList)
  { 
    var param_list            =    this.router.query;
    param_list.col_name       =    column.sortField;
    param_list.order          =    sortDirection;
    addParamsToUrl(param_list, this.router);
    
    var data  =  await this.listAssessments(param_list);
    setAssessmentList(data);   
  }

  async handleAssessmentPerRowsChange(per_page, setAssessmentList)
  {
    var param_list            =    this.router.query;
    param_list.per_page       =    per_page;
    addParamsToUrl(param_list, this.router);
    var data                =    await this.listAssessments(param_list);
    setAssessmentList(data);  
  }

  async handleAssessmentPageChange(page_number, setAssessmentList)
  {
    var param_list        =    this.router.query;
    param_list.page       =    page_number;
    addParamsToUrl(param_list, this.router);
    var data            =    await this.listAssessments(param_list); 
    setAssessmentList(data);    
  }

  async deleteAssessment(currentRow, setAssessmentDeleteModal, setAssessmentList){
    var result =  await this.manageAssessmentService.deleteAssessment(currentRow.id); 
    this.setApiError(result.request);
    if(result.request.status == 200){
      setAssessmentDeleteModal({state: false})
      this.customToastrAction.setNormalToastr(result.data.success, 'success');
      setAssessmentList(result.data);  
    }      
  }

  async createAssessment(values, setAssessmentCreateModal, setAssessmentList){
    const params = this.setFormData(values)
    var result =  await this.manageAssessmentService.createAssessment(params); 
    this.setApiError(result.request);
    if(result.request.status == 200){
      setAssessmentCreateModal({state: false})
      this.customToastrAction.setNormalToastr(result.data.success, 'success');
      setAssessmentList(result.data);  
    }  
    else{
      return result.response.data.error.assessment
    } 
  }

  async updateAssessment(values, setAssessmentCreateModal, setAssessmentList){
    const params = this.setFormData(values)
    var result =  await this.manageAssessmentService.updateAssessment(params, values.id); 
    this.setApiError(result.request);
    if(result.request.status == 200){
      setAssessmentCreateModal({state: false})
      this.customToastrAction.setNormalToastr(result.data.success, 'success');
      setAssessmentList(result.data);  
    }   
    else{
      return result.response.data.error.assessment
    } 
  }

  setFormData(params){
    const data = {
      assessment: {
        name: params.name,
        file_type: params.file_type,
        link: params.link,
      }
    }
    if(params.file){
      data.assessment.file = params.file
      data.assessment.filename = params.filename
    }
    return data
  }

  async uploadFile(formik, files, event){
    const file = files[0]
    if(file)
    { 
      formik.setFieldValue('file_type', 'file')
      if(file.size > MANAGE_ASSESSMENT.file_size){
        await formik.setFieldValue('file', '')
        await formik.setFieldValue('filename', file.name)
        await formik.setFieldValue('filesize', file.size)
      }
      else{
        const base64 = await this.commonAction.convertToBase64(file);
        await formik.setFieldValue('filename', file.name)
        await formik.setFieldValue('file', base64)
        await formik.setFieldValue('filesize', file.size)
      }
    }
  }

  async onRemoveFile(formik){
    await formik.setFieldValue('file_type', 'link')
    await formik.setFieldValue('file', '')
    await formik.setFieldValue('filename', '')
  }

  async onOptionChange(formik, event){
    let val = event.target.value
    if(val == 'file') {
      await formik.setFieldValue(event.target.name, val)
      await formik.setFieldValue('link', '')
    }
    else{
      await formik.setFieldValue(event.target.name, val)
      await formik.setFieldValue('file', '')
      await formik.setFieldValue('filename', '')
    }
  }

  addHttpOrHttps(link){
    let downcaseUrl = link.toLowerCase()
    if (downcaseUrl.indexOf("http://") == 0 || downcaseUrl.indexOf("https://") == 0) {
      return downcaseUrl;
    }
    else{
      return "https://"+downcaseUrl
    }
  }

  assessmentActionOptions(row, t){
    let options = [{
      'key': 'edit',
      'title': t('datatable:actions:edit'),
      'action': 'edit',
    },
    {
      'key': 'delete',
      'title': t('datatable:actions:delete'),
      'action': 'delete',
    }]
    return options;
  }

  openJobOptions(event)
  {
    event.stopPropagation();
    var dots_element = event.currentTarget.querySelector('.Dots');
    var element = event.currentTarget.querySelector('.JobActionOptions')

    if(dots_element.classList.contains('Close'))
    {
      this.closeAllJobsOptions();
      element.classList.remove('Close');
      element.classList.add('Open');

      dots_element.classList.remove('Close');
      dots_element.classList.add('Open');
    }
    else
    {
      this.closeAllJobsOptions();
      element.classList.remove('Open');
      element.classList.add('Close');

      dots_element.classList.remove('Open');
      dots_element.classList.add('Close');
    }
  } 

  closeAllJobsOptions()
  {
    var element = document.querySelector('.JobActionOptions.Open');
    var dots_element = document.querySelector('.Dots.Open');
    if(element)
    {
      element.classList.remove('Open');
      element.classList.add('Close');
      dots_element.classList.remove('Open');
      dots_element.classList.add('Close');
    }
  }

  async performAssessmentAction(ActionName, params){
    this.closeAllJobsOptions();
    switch(ActionName)
    {
      case 'edit':
        params.setAssessmentAction('edit')
        params.setCurrentRow(params.row)
        params.setAssessmentCreateModal({state: true})
        break;
      case 'delete':
        await params.setCurrentRow(params.row)
        await params.setAssessmentDeleteModal({state: true})
        break;
    }
  }

  getAssessmentColumnsName(setAssessmentDeleteModal, setCurrentRow, setAssessmentAction, setAssessmentCreateModal, t){
    const columns = [
      {
        name: t('datatable:assessment_name'),
        selector: row => row.name,
        sortable: true, 
        sortField: 'name'  
      },
      {
        name: t('datatable:file/link'),
        selector: row => {
          if(row.file_type == 'file')
          { 
            return <a href={row.file_or_link} target="_blank" className={`termslink`}>{row.file_name}</a>
          }
          else{
            return <a href={this.addHttpOrHttps(row.file_or_link)} target="_blank" className={`termslink`}>{row.file_or_link}</a>
          }
        }
      },
      {
        name: t('datatable:updated_on'),
        selector: row => row.added_on,
        sortable: true, 
        sortField: 'created_at'  
      },
      {
        name: t('datatable:updated_by'),
        selector: row => {
          return(  
            <div className="CandidateSection">
              {row.added_by?.photo_url ? <img src={row.added_by?.photo_url} className="JobImage"/> 
                                        : <div className="JobInitial">
                                            <span>{row.added_by.name_initials ? row.added_by.name_initials : "?"}</span>
                                          </div>}
              <div className="JobName">  {row.added_by.name || row.added_by.email}</div>
            </div>
          )
        },
        sortable: true, 
        sortField: 'added_by'  
      },
      {
        name: '',
        selector: row => <div className="DotsOptions" onClick={(event) => this.openJobOptions(event)}> 
        <Dots className="Dots Close" />
        {<AssessmentActionOptions options  =  {this.assessmentActionOptions(row, t)} 
                              row         = {row}
                              setApiError = {this.setApiError}
                              router      = {this.router}
                              setAssessmentList = {this.setAssessmentList}
                              performAssessmentAction = {this.performAssessmentAction}
                              closeAllJobsOptions = {this.closeAllJobsOptions}
                              setAssessmentDeleteModal = {setAssessmentDeleteModal}
                              setCurrentRow = {setCurrentRow}
                              customToastrAction = {this.customToastrAction}
                              setAssessmentAction = {setAssessmentAction}
                              setAssessmentCreateModal = {setAssessmentCreateModal}
          />
        }
        </div>,
      },
    ];
    return columns;
  }
}